<template>
  <div v-loading.fullscreen.lock="loading" class="main_center clearfix">

    <div class="top-content">
        <div class="left-navbar">
          <el-button size="small" @click="backBtn">返回</el-button>
          <!--                    <right-nav :childData='listNav'></right-nav>  -->
          <el-button type="primary" size="small" plain style="margin-right:10px;" @click="save()">保存</el-button>
          
        </div>
      </div>
    <el-form ref="form" :model="form" :rules='rules' label-width="150px" class="form">
      <div class="right-content">
        <el-card class="box-card" :style="{'height':cardHight}">
          <div slot="header" class="clearfix">
            <span>配置信息</span>
          </div>

          <el-row>
            <el-col :span="12">
              <el-form-item label="名称：" prop='name' style="width:100%;">
                <el-input v-model="form.name" maxlength="50" show-word-limit ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="流id：" prop='streamId' style="width:100%;">
                <el-input v-model="form.streamId" maxlength="50" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="流媒体地址：" prop='streamUrl' style="width:100%;">
                <el-input v-model="form.streamUrl" maxlength="255" show-word-limit></el-input>
              </el-form-item>
            </el-col>
<!--            <el-col :span="24">-->
<!--              <el-form-item label="门禁位置：" prop='location' style="width:100%;">-->
<!--                <el-input type="textarea" v-model="form.location" maxlength="50" show-word-limit></el-input>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-col :span="12">
              <el-form-item prop="location" label="场地楼层：">
                <el-select v-model="form.location" placeholder="请选择">
                  <el-option
                          v-for="item in filedFloorOptions"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="tradeOrgId" label="所属交易中心：">
                <el-select v-model="form.tradeOrgId" placeholder="请选择">
                  <el-option
                          v-for="item in traddingList"
                          :key="item.id"
                          :label="item.orgName"
                          :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="发布：" prop='pubFlag' style="width:100%;">
                <el-col :span="12">
                  <el-switch
                      v-model="form.pubFlag"
                      :active-value="1"
                      :inactive-value="0"
                      active-color="#13ce66"
                      inactive-color="#c0c0c0">
                  </el-switch>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

        </el-card>
      </div>
      
    </el-form>
  </div>
</template>

<script>

  import {strLength_5} from '../../../utils/validate';
  // import {tabsCloseCurrentHandle} from '@/utils/routeTab';

  export default {
  components: {},
  data() {
    return {
      cardHight: (document.documentElement.clientHeight - 192) + 'px',
      loading: false,
      form: {
        id: '',//id
        name: '',//名称
        streamId: '', //流id
        streamUrl: '',//流媒体地址
        pubFlag: '',//发布标记 1已发布 0未发布
        location:'',// 所属楼层
        tradeOrgId:'', // 所属交易中心
      },
      filedFloorOptions:[],
      traddingList:[],
      rules: {
        name: [{required: true, message: '请输入名称', trigger: 'blur'}, {validator: strLength_5, trigger: 'blur'}],
        streamId: [{required: true, message: '请输入名称', trigger: 'blur'}, {validator: strLength_5, trigger: 'blur'}],
        location: [{required: true, message: '请选择所属楼层', trigger: 'change'}],
        tradeOrgId: [{required: true, message: '请选择所属楼层', trigger: 'change'}],
      },
      upAddIndex: '', //判断是新增还是详情页
      saveClick: false,
      errorData: {},
    }
  },

    created() {
      this.getDic('loucengbianma')
      this.getTraddingList();
    },
    activated() {



    this.form.id = window.sessionStorage.getItem("id");
    this.getDataById();

    this.upAddIndex = window.sessionStorage.getItem("addUpdateIndex");

  },
  computed: {},
  methods: {

    getDic() { // 获取字典
      this.$httpReq.get('/sys/dictData/getList?type=loucengbianma').then(res => {
        if (res.data.code === '1') {
          this.filedFloorOptions = res.data.data;
        }
      })
    },
    getTraddingList() {
      this.$httpReq.post('/sysGuardConfig/traddingOrgPage',{
        "page": 1,
        "rows": 10,
        "searchKey": "",
      }).then(res => {
        this.traddingList = res.data.rows || [];
      })
    },

    backBtn() { //返回
      tabsCloseCurrentHandle();
      this.clearData()
      this.$router.push({
        name: 'guard_config_list'
      })

    },
    clearData() {
      this.$refs.form.resetFields();
    },
    getDataById() { //详情

      if (this.form.id != "") {

        this.$httpReq.get('/sysGuardConfig/get?id=' + this.form.id).then(res => {
          if (res.data.code == '1') {
            this.form.id = res.data.data.id
            const data = res.data.data
            this.form = {
              id: this.form.id,
              name: data.name,//名称
              streamId: data.streamId, //流id
              streamUrl:data.streamUrl,//流媒体地址
              pubFlag: data.pubFlag,//发布标记 1已发布 0未发布
              location:data.location,
              tradeOrgId:data.tradeOrgId,
            }
          }
        })

      } else {
        //  新增
        this.$refs['form'].resetFields();

      }
    },
    save() { //新增&保存

      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$httpReq.post('/sysGuardConfig/save', this.form).then(res => {
            if (res.data.code == '1') {

              this.form.id = res.data.data.id
              window.sessionStorage.setItem("id", res.data.data.id);

              this.$message({
                type: 'success',
                message: res.data.msg
              })
              this.$router.push({
                name: 'guard_config_view'
              })
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
              this.errorData = res.data.data || {};
            }
          })

        }
      })
    },


  }
}
</script>

<style lang="scss" scoped>
.main_center {
  height: 100%;

  .right-content {
    .set_btn {
      float: right;
      margin-bottom: 20px;
    }

    .more_btn {
      text-align: center;
    }

    .upload-demo {
      display: flex;
      height: 34px;
      border-bottom: 1px solid #dcdfe6;

      .el-button {
        position: absolute;
        right: 0;
      }
    }
  }
}

.el-dialog__body {
  padding-top: 0;

  .dia_top {
    text-align: center;
    margin-top: -3%;
  }

  .dialog_title {
    text-align: right;
    box-sizing: border-box;
    border: 1px solid #ebeef5;
    padding: 10px 10px 10px 0;
    border-bottom: none;

    .search_btn {
      margin-left: 20px;
    }
  }
}

.backBtn {
  margin-right: 10%;
}
</style>